const CallingAutomaticallyStatus = {
  Active: 'active',
  Paused: 'paused',
};

const CallingAutomaticallyReason = {
  Login: 'login',
  Logout: 'logout',
  PausedByCron: 'paused-by-cron',
  NotValidData: 'not-valid-data',
  NoReason: 'no-reason',
  None: '',
};

const CallingAutomaticallyDefaultValue = {
  status: CallingAutomaticallyStatus.Paused,
  reason: CallingAutomaticallyReason.Login,
  serviceId: '',
  serviceType: '',
};

module.exports = {
  CallingAutomaticallyStatus,
  CallingAutomaticallyReason,
  CallingAutomaticallyDefaultValue,
};
